export default __webpack_public_path__ + "static/media/bull-two.d7de7b72.png";